/* eslint-disable @typescript-eslint/no-explicit-any */
import { put } from 'redux-saga/effects';

import { handleApiError } from '../../../api';
import * as ofwcaPathApi from '../services/api';

import { OfwcaPathActions } from './ofwcaPath.actions';
import {
  DownloadResourceAction,
  FetchSignedDocumentsAction,
  FinishFormAction,
  GenerateTokenAction,
  SendAnswersAction,
  UploadFileAction,
  VerifyTokenAction,
} from './ofwcaPath.types';

import type { AxiosResponse } from 'axios';

function* initWelcomeScreenAction(): Generator {
  const data: any = yield ofwcaPathApi.sendAnswers({
    section: 'welcome_screen',
    data: {
      fields: {
        status: 'not_started',
      },
    },
  });

  if (data.status === 200) {
    yield put(OfwcaPathActions.setFields(data.data));
  }
}

export function* fetchFormData(): Generator {
  // TODO: remove this any
  const data: any = yield ofwcaPathApi.fetchFormData();

  if (data.status === 200) {
    yield put(OfwcaPathActions.setFields(data.data));
  } else {
    yield initWelcomeScreenAction();
  }
}

export function* sendAnswers({ answers, onFinish }: SendAnswersAction): Generator {
  // TODO: remove this any
  const data: any = yield ofwcaPathApi.sendAnswers(answers);

  if (data.status === 200) {
    yield put(OfwcaPathActions.setFields(data.data));
    onFinish();
  }
}

export function* fetchRelatedStations(): Generator {
  // TODO: remove this any
  const { data }: any = yield ofwcaPathApi.fetchRelatedStations();
  yield put(OfwcaPathActions.setRelatedStations(data));
}

export function* generateToken({ hash, onFinish }: GenerateTokenAction): Generator {
  // TODO: remove this any
  const data: any = yield ofwcaPathApi.generateToken(hash);

  if (data.status >= 200 && data.status < 300) {
    onFinish();
  }
}

export function* verifyToken({ token, onFinish, onError }: VerifyTokenAction): Generator {
  // TODO: remove this any
  const data: any = yield ofwcaPathApi.verifyToken(token);

  if (data.status >= 200 && data.status < 300) {
    onFinish();
  } else {
    onError();
  }
}

export function* uploadFile({ formData, onFinish }: UploadFileAction): Generator {
  // TODO: remove this any
  const data: any = yield ofwcaPathApi.uploadFile(formData);

  if (data.status === 200) {
    onFinish(data.data);
  }
}

export function* fetchSignedDocuments({ onFinish }: FetchSignedDocumentsAction): Generator {
  // TODO: remove this any
  const { data }: any = yield ofwcaPathApi.fetchSignedDocuments();

  if (data) {
    yield put(OfwcaPathActions.setSignedDocuments(data));
    if (onFinish) {
      onFinish(data);
    }
  }
}

export function* finishForm({ onFinish }: FinishFormAction): Generator {
  // TODO: remove this any
  const { data }: any = yield ofwcaPathApi.finishForm();

  if (data?.success) {
    onFinish();
  }
}

export function* downloadResource({ uid, onFinish, resourceType }: DownloadResourceAction): Generator {
  try {
    const { data, status }: AxiosResponse<Blob> = (yield ofwcaPathApi.downloadResource(uid, resourceType)) as AxiosResponse<Blob>;

    if (status === 200) {
      onFinish(data);
    }
  } catch (error: unknown) {
    handleApiError(error);
  }
}
